<template>
  <div class="table-funcionalidades">
    <div class="table-funcionalidades__toolbar">
      <v-text-field
        v-model="termoBusca"
        placeholder="Buscar módulo ou ação, ex: ticket, agenda…"
        :prepend-inner-icon="icons.mdiMagnify"
        outlined
        dense
        hide-details
        clearable
        class="table-funcionalidades__busca"
      />

      <span class="table-funcionalidades__resumo">
        {{ totalSelecionadas }} de {{ totalFuncionalidades }} permissões marcadas
      </span>
    </div>

    <div
      v-if="modulosFiltrados.length === 0"
      class="table-funcionalidades__vazio"
    >
      Nenhum módulo ou ação encontrada para essa busca.
    </div>

    <div
      v-else
      class="table-funcionalidades__lista"
    >
      <funcionalidade-agrupadora
        v-for="modulo in modulosFiltrados"
        :key="modulo.nomeExibicao"
        :modulo="modulo"
        :nova-lista="novaLista"
        :termo-busca="termoBusca"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { mdiMagnify } from '@mdi/js'
import FuncionalidadeAgrupadora from './FuncionalidadeAgrupadora.vue'

function normalizar(texto) {
  return (texto || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
}

export default {
  components: {
    FuncionalidadeAgrupadora,
  },

  props: {
    modulos: {
      type: Array,
      default: () => [],
    },
    novaLista: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const termoBusca = ref('')

    const moduloBateBusca = (modulo, termo) => {
      if (normalizar(modulo.nomeExibicao).includes(termo)) return true

      return modulo.funcionalidades.some(agrupadora => normalizar(agrupadora.nomeExibicao).includes(termo)
        || agrupadora.filhos.some(f => normalizar(f.nomeExibicao).includes(termo)))
    }

    const modulosFiltrados = computed(() => {
      const termo = normalizar(termoBusca.value.trim())

      if (!termo) return props.modulos

      return props.modulos.filter(modulo => moduloBateBusca(modulo, termo))
    })

    const todasAsFuncionalidades = computed(() => props.modulos
      .flatMap(modulo => modulo.funcionalidades)
      .flatMap(agrupadora => agrupadora.filhos))

    const totalFuncionalidades = computed(() => todasAsFuncionalidades.value.length)

    const totalSelecionadas = computed(() => todasAsFuncionalidades.value
      .filter(f => f.isChecked || props.novaLista.funcionalidadesIds.includes(f.id)).length)

    return {
      termoBusca,
      modulosFiltrados,
      totalFuncionalidades,
      totalSelecionadas,
      icons: {
        mdiMagnify,
      },
    }
  },
}
</script>

<style scoped>
.table-funcionalidades__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 16px 16px;
}

.table-funcionalidades__busca {
  flex: 1;
  max-width: 420px;
}

.table-funcionalidades__resumo {
  font-size: 13px;
  opacity: 0.7;
  white-space: nowrap;
}

.table-funcionalidades__lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px 16px;
}

.table-funcionalidades__vazio {
  padding: 32px 16px;
  text-align: center;
  opacity: 0.6;
  font-size: 13.5px;
}
</style>
